// extracted by mini-css-extract-plugin
export default {"container":"X5CU56","noWrapContainer":"EFkmhD","logo":"uZhkcw","infoButton":"uapyN2","dark":"U9LM6y","light":"qBdhrv"};